module.exports = __webpack_public_path__ + "static/media/RE-open.49e4f4ba.svg";